export function getNewsUrl(url: string, status: string[]) {
  if (!status) return `${url}status=show`;
  const statusUrl = `status=${status?.join("+")}`;
  let finalUrl = `${url}${statusUrl}`;

  // if (filters) {
  //   finalUrl =
  //     filters?.length > 0 && !filters.includes("All")
  //       ? `${url}${statusUrl}`
  //       : `${url}${statusUrl}`;
  // }
  if (finalUrl.endsWith("=")) {
    return finalUrl;
  }

  return finalUrl;
}

export function setTags(value: string): string[] {
  // let tags = value.replace(/\s/g, "").split(",");
  let tags = value.split(",");
  return tags;
}

export const scrollToTop = (ref?: any) => {
  if (ref && ref.current) {
    ref.current.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const mainBody = document.getElementById("mainBody");
  if (mainBody) {
    mainBody.scrollTo(0, 0);
  }
};

export function dateFormat(date: Date): string {
  if (!date) return "";
  const newDate = new Date(date);
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  };
  // @ts-ignore
  const formatter = new Intl.DateTimeFormat(undefined, options);
  return formatter.format(newDate);
}

export const formatCurrency = (value: number | string): string => {
  // if(!value) return ""
  const convertedValue = typeof value === "string" ? parseFloat(value) : value;

  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
    currencyDisplay: "symbol",
  }).format(convertedValue);
};

export const getFormattedApplicantsInfo = (applicants: {
  [key: string]: any;
}): any[] => {
  const applArr = Array.from(
    { length: Object.keys(applicants).length / 4 },
    (_, index) => ({
      "first-name": applicants[`first-name-${index + 1}`],
      "last-name": applicants[`last-name-${index + 1}`],
      email: applicants[`email-${index + 1}`],
      phone: applicants[`phone-${index + 1}`],
    })
  );
  return applArr;
};

export const getRelationshipInfo = (rel: { [key: string]: any }): any[] => {
  // const rel = data.inputData.rel_info;
  const relArr = Array.from(
    { length: Object.keys(rel).length / 3 },
    (_, index) => ({
      "relationship-status": rel[`relationship-status-${index + 1}`],
      extraInfo:
        rel[`deFactoWith-${index + 1}`] === "non" &&
        rel[`marriedTo-${index + 1}`] === "non"
          ? ""
          : rel[`deFactoWith-${index + 1}`] === "non"
          ? `(${rel[`marriedTo-${index + 1}`]})`
          : `(${rel[`deFactoWith-${index + 1}`]})`,
    })
  );
  return relArr;
};

export const getBeforeTaxInfo = (beforeTax: { [key: string]: any }): any[] => {
  const beforeTaxArr = Array.from(
    { length: Object.keys(beforeTax).length / 4 },
    (_, index) => ({
      "annual-salary": beforeTax[`annual-salary-${index + 1}`],
      "other-income": beforeTax[`other-income-${index + 1}`],
    })
  );
  return beforeTaxArr;
};

export function formatDateTime(dateString: string): string {
  const convertedDateString = `${dateString.split("-")[1]}-${
    dateString.split("-")[0]
  }-${dateString.split("-")[2]}`;
  const date = new Date(convertedDateString);

  const year = date.getFullYear().toString().slice(-2);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}.${month}.${year} (${hours}:${minutes}:${seconds})`;
}

export function formatHeadings(text: string): string {
  return text
    .toLowerCase()
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatCalcName(string: string): string {
  const formattedString = string.replace(/([a-z])([A-Z])/g, "$1 $2");
  return formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
  // return `${calcType.slice(0, 1).toUpperCase()}${calcType.slice(1)}`
}

export function formatDocName(string: string): string {
  return string
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function toDataURL(url: string, callback: Function) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

export function getImageExtensionFromBase64(base64String: string) {
  // Split the base64 string into two parts, the first part is the MIME type and the second part is the image data.
  const parts = base64String.split(";base64,");

  // Get the MIME type.
  const mimeType = parts[0].split("/")[1];

  // Remove the `+xml` from the MIME type.
  const extension = mimeType.replace("+xml", "");

  // Return the file extension.
  return extension;
}

export function convertFileToBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
}

export function base64ToBinary(base64: string): Uint8Array {
  if (base64?.length > 30) {
    const binaryString = atob(base64);
    const length = binaryString.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }
  return new Uint8Array();
}

export function createFileFromBase64(
  base64: string,
  fileName: string,
  mimeType: string
): File {
  const binary = base64ToBinary(base64);
  return new File([binary], fileName, { type: mimeType });
}

export function removeKeyFromObject(obj: any, keyToRemove: string) {
  const { [keyToRemove]: _, ...rest } = obj;
  return rest;
}

export function sortByDate(data: any, key: string) {
  return data.sort((a: any, b: any) => {
    return (
      (new Date(Date.parse(b[key])) as any) -
      new Date(Date.parse(a[key])).getTime()
    );
  });
}

export const isEmpty = (data: any): boolean => {
  if (!data) return true;
  if (Array.isArray(data) && data.length === 0) {
    return true;
  }

  if (typeof data === "object" && data !== null) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (!isEmpty(data[key])) {
          return false;
        }
      }
    }
    return true;
  }

  return false;
};
